import styled, { keyframes } from 'styled-components'
import { CSS } from 'ui/helpers'

const FileItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey300};
`

const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  box-sizing: border-box;
  gap: 12px;
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`

const FileInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;

  > div {
    display: flex;
    flex-direction: row;
    gap: 4px;
  }
`

const FileName = styled.span`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)}
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`

const FileStatus = styled.span`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)}
`

const UploadedLink = styled.a`
  color: #0066cc;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #0052a3;
  }
`

const ProgressBar = styled.div<{ $isShrinking?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  background: white;
  --theme-size-grid: 4px;
  --theme-borderRadius-roundedFull: 2px;
  --theme-colors-theme-positive-main: ${(p) => p.theme.uiKit.colors.global.grey.grey300};
  --theme-colors-theme-brand-darker: ${(p) => p.theme.uiKit.colors.theme.brand.primary};
  transform-origin: bottom;
  transition: ${(p) => (p.$isShrinking ? 'transform 0.5s ease, opacity 0.5s ease' : 'none')};
  transform: ${(p) => (p.$isShrinking ? 'scaleY(0)' : 'scaleY(1)')};
  opacity: ${(p) => (p.$isShrinking ? 0 : 1)};
  overflow: hidden;

  & > div {
    width: 100%;
  }

  & > div > div > div:last-child {
    transition: width 0.15s ease;
    min-width: 2px;
  }
`

const FileActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

const ActionButton = styled.button`
  background: none;
  border: none;
  color: #0066cc;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  padding: 0;

  &:hover {
    color: #0052a3;
  }
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const SpinnerWrapper = styled.div`
  animation: ${rotate} 2s infinite linear;
`

export const s = {
  FileItemWrapper,
  FileItem,
  InfoWrapper,
  FileInfo,
  FileName,
  IconWrapper,
  FileStatus,
  UploadedLink,
  ProgressBar,
  FileActions,
  ActionButton,
  SpinnerWrapper
}
